export class OktaUser {
  Name?: string;
  UserName?: string;
  Email?: string;
  Phone_number?: string;
  Given_name?: string;
  Family_name?: string;
  Groups?: string;
  CRMID?: string;
  OrganizationID?: string;
  ExportOrganizationID?: string;
  Updated_at?: Date;
  Token?: string;
}

export class HubUser {
  ID?: string;
  UserName?: string;
  FirstName?: string;
  LastName?: string;
  Initials?: string;
  ChipColor?: string;
  Title?: string;
  Groups?: string;
  Organization?: string;
  OrgName?: string;
  ExportOrganization?: string;
  ExportOrgName?: string;
  ProfilePicture?: string;
  CreationDate?: string;
  ModifiedDate?: string;
  LastLoginDate?: string;
  AccountStatus?: boolean;
  HubGroups?: HubGroup[];
  Details?: string;
  Email?: string;
}

export class HubGroup {
  value?: HubGroup;
  label?: string;
  id?: number;
  group?: string;
  permissions?: HubPermission[];
}


export class HubPermission {
  id: number;
  permission?: "";
  allowedRoutes?: HubRoute[];
}

export  class HubRoute {
  id: number;
  route?: string;
}

export class HubBasicGroupUser {
  id: number;
  orgid: number;
  public roleid: number;
  username: string;
  password: string;
  name: string;
  firstName: string;
  lastName: string;
  Initials?: string;
  ChipColor?: string;
  token: string;
}
